import { Routes, Route } from "react-router-dom";
import ErrorPage from "../pages/ErrorPage";

const PublicRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/notFound" element={<ErrorPage testIntegration={false} />} />
                <Route path="/mismatch" element={<ErrorPage testIntegration={true} />} />
            </Routes>
        </>

    );
}

export default PublicRoutes